import { render, staticRenderFns } from "./UserProfileEdit.vue?vue&type=template&id=58b5cf1e&scoped=true"
import script from "./UserProfileEdit.vue?vue&type=script&lang=ts"
export * from "./UserProfileEdit.vue?vue&type=script&lang=ts"
import style0 from "./UserProfileEdit.vue?vue&type=style&index=0&id=58b5cf1e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5cf1e",
  null
  
)

export default component.exports